module.exports = __webpack_public_path__ + "img/php.5525e77a.png";